import React from "react";
import { Result, Button } from "antd";
import strings from "../utils/Localization";
import { useNavigate } from "react-router-dom";

function Page404() {
  const navigate= useNavigate();
  const { geriDonButton, mesajBaslik } = strings.page404;
  return (
    <Result
      status="404"
      title="404"
      subTitle={mesajBaslik}
      extra={
        <Button type="primary" onClick={() => navigate(-1)}>
          {geriDonButton}
        </Button>
      }
    />
  );
}

export default Page404;
